<template>
  <div class="page-header-back-button d--f ai--c" @click="handleClick">
    <AppIcon color="primary" type="arrow-back" size="28" class="pl-30px pr-30px" />
  </div>
</template>

<script setup>
import { AppIcon } from "@/components/ui";
import { useRouter } from "vue-router";

const props = defineProps({
  route: {
    type: Object,
    required: true,
  },
});

const router = useRouter();

const handleClick = () => {
  router.push(props.route);
};
</script>

<style lang="scss" scoped>
.page-header-back-button {
  height: 100px;
  border-right: 1px solid $color-grey-1;
  text-decoration: none;

  &:hover {
    background-color: $color-grey-1;
  }
}
</style>
